import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { money } from "@/components/settlement/SupplierSettlement";

// ID-057: compact supplier settlement overview on the Dashboard (details live under Suppliers)
export function SettlementOverviewCard() {
  const [o, setO] = useState(null);
  useEffect(() => { api.get("/admin/supplier-settlement/overview").then(({ data }) => setO(data)).catch(() => {}); }, []);
  if (!o) return null;
  return (
    <section className="mt-10 rounded-md border border-border bg-white p-5" data-testid="dashboard-settlement-card">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-charcoal">Supplier settlement</p>
        <Link to="/admin/suppliers" className="text-xs text-terracotta underline" data-testid="dashboard-settlement-link">Open suppliers</Link>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-3 sm:grid-cols-4">
        {[["Total owed to suppliers", money(o.total_owed_usd), "owed"], ["Total paid", money(o.total_paid_usd), "paid"], ["Remaining balance owed", money(o.remaining_owed_usd), "remaining"],
          ["Payment progress", o.payment_progress_pct == null ? "—" : `${o.payment_progress_pct}%`, "progress"]].map(([l, v, k]) => (
          <div key={k}><p className="text-xs text-warmgrey">{l}</p><p className="num text-lg font-semibold text-charcoal" data-testid={`dashboard-settlement-${k}`}>{v}</p></div>
        ))}
      </div>
      <div className="mt-3 space-y-1" data-testid="dashboard-settlement-attention">
        {o.attention.length === 0 ? <p className="text-xs text-muted-foreground">No supplier needs attention.</p> : o.attention.map((a) => (
          <p key={a.supplier_id} className="text-xs text-charcoal"><Link to={`/admin/suppliers/${a.supplier_id}`} className="font-medium text-terracotta underline" data-testid={`attention-${a.code}`}>{a.name}</Link> — {a.reasons.join(" · ")}</p>
        ))}
      </div>
    </section>
  );
}
